import { ResourceAppModule } from "@/shared/app";
import { plmApp } from "../app";
import { Podloze, podlozeResource } from "@megarax/client/src/resources/plm";

export const podlozeModule: ResourceAppModule = {
  app: plmApp,
  formComponent: () => import("./ItemForm.vue"),
  sheetComponent: () => import("./ItemSheet.vue"),
  listComponent: () => import("./ItemList.vue"),
  title: "Podłoża",
  route: "podloze",
  itemConstructor: Podloze,
  resource: podlozeResource,
};
